import { useMemo } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { detectBlockchainInput } from '../explorer/detectInput';
import BlockResolverView from './BlockResolverView';
import EvmBlockDetailsView from './EvmBlockDetailsView';
import EvmTransactionDetailsView from './EvmTransactionDetailsView';
import PrcTransactionDetailsView from './PrcTransactionDetailsView';
import PrcWalletDetailsView from './PrcWalletDetailsView';
import SolanaTransactionDetailsView from './SolanaTransactionDetailsView';
import TronTransactionDetailsView from './TronTransactionDetailsView';

function TransactionDetailsPage() {
  const { signature: id } = useParams();
  const detection = useMemo(
    () => detectBlockchainInput(id || ''),
    [id],
  );

  if (detection?.chain === 'prc' && detection.type === 'transaction') {
    return <PrcTransactionDetailsView hash={id} />;
  }

  if (detection?.chain === 'prc' && detection.type === 'address') {
    return <PrcWalletDetailsView address={id} />;
  }

  if (detection?.chain === 'tron' && detection.type === 'transaction') {
    return <TronTransactionDetailsView hash={id} />;
  }

  if (detection?.chain === 'solana' && detection.type === 'transaction') {
    return <SolanaTransactionDetailsView signature={id} />;
  }

  if (detection?.chain === 'evm' && detection.type === 'transaction') {
    return <EvmTransactionDetailsView hash={id} />;
  }

  if (detection?.chain === 'evm' && detection.type === 'block') {
    return <EvmBlockDetailsView number={id} />;
  }

  if (detection?.chain === 'block' && detection.type === 'block') {
    return <BlockResolverView query={id} />;
  }

  if (detection?.type === 'transaction' && id) {
    return <Navigate to={`/lookup?q=${encodeURIComponent(id)}`} replace />;
  }

  if (detection?.type === 'block' && id) {
    return <BlockResolverView query={id} />;
  }

  return <SolanaTransactionDetailsView signature={id} />;
}

export default TransactionDetailsPage;
